<template>
  <div class="layout-padding">
    <div class="billing-address">
      <h5>Billing Address</h5>
      <div class="row">
        <form autocomplete="off" class="col" @submit.prevent=";">
          <q-field
            class="q-pa-md col-12"
            :error="validation.billingAddressForm.ADDRESS_1.$error"
            error-label="Address required"
          >
            <q-input
              float-label="Address 1"
              :value="billingAddressForm.ADDRESS_1"
              :after="[
              {icon: 'flag', class: 'exclamation-circle-icon', condition: validation.billingAddressForm.ADDRESS_1.$invalid },
              {icon: 'fa fa-check', condition: !validation.billingAddressForm.ADDRESS_1.$invalid}
            ]"
              autocomplete="false"
              @blur="validation.billingAddressForm.ADDRESS_1.$touch"
              :disable="!canEdit"
              v-places-autocomplete="billingPlaceChanged"
              @keyup.stop="updateBillingAddressForm({ field: 'ADDRESS_1', value: $event.target.value })"
            ></q-input>
          </q-field>
        </form>
      </div>
      <div class="row">
        <form autocomplete="off" class="col">
          <q-field class="q-pa-md col-12">
            <q-input
              float-label="Address 2"
              :value="billingAddressForm.ADDRESS_2"
              @keyup.stop="updateBillingAddressForm({ field: 'ADDRESS_2', value: $event.target.value })"
              :disable="!canEdit"
              required
              autocomplete="off"
            ></q-input>
          </q-field>
        </form>
      </div>
      <div class="row">
        <q-field
          class="q-pa-md col-3"
          :error="validation.billingAddressForm.CITY.$error"
          error-label="City required"
        >
          <q-input
            float-label="City"
            :value="billingAddressForm.CITY"
            :after="[
              {icon: 'flag', class: 'exclamation-circle-icon', condition: validation.billingAddressForm.CITY.$invalid, handler () {}},
              {icon: 'fa fa-check', condition: !validation.billingAddressForm.CITY.$invalid}
            ]"
            @blur="validation.billingAddressForm.CITY.$touch"
            :disable="!canEdit"
            @keyup.stop="updateBillingAddressForm({ field: 'CITY', value: $event.target.value })"
          ></q-input>
        </q-field>
        <q-field
          class="q-pa-md col-3"
          :error="validation.billingAddressForm.LK_STATE_ID.$error"
          error-label="State required"
        >
          <q-select
            float-label="State"
            :ref="'billingStateDropdown'"
            :value="billingAddressForm.LK_STATE_ID"
            :options="stateOptions"
            :after="[
              {icon: 'flag', class: 'exclamation-circle-icon', condition: validation.billingAddressForm.LK_STATE_ID.$invalid, handler () {}},
              {icon: 'fa fa-check', condition: !validation.billingAddressForm.LK_STATE_ID.$invalid}
            ]"
            clearable
            :disable="!canEdit"
            @change="val => updateBillingAddressForm({ field: 'LK_STATE_ID', value: val })"
            @focus="onDropdownFocus('billingStateDropdown')"
            filter
            autofocus-filter
          />
        </q-field>
        <q-field
          class="q-pa-md col-3"
          :error="validation.billingAddressForm.ZIP_CODE.$error"
          error-label="Requires 5 characters"
        >
          <q-input
            float-label="Zip"
            :value="billingAddressForm.ZIP_CODE"
            :after="[
              {icon: 'flag', class: 'exclamation-circle-icon', condition: validation.billingAddressForm.ZIP_CODE.$invalid, handler () {}},
              {icon: 'fa fa-check', condition: !validation.billingAddressForm.ZIP_CODE.$invalid}
            ]"
            @blur="validation.billingAddressForm.ZIP_CODE.$touch"
            @keyup.stop="updateBillingAddressForm({ field: 'ZIP_CODE', value: $event.target.value })"
            :disable="!canEdit"
            required
          ></q-input>
        </q-field>
        <q-field
          class="q-pa-md col-3"
          :error="validation.billingAddressForm.COUNTY.$error"
          error-label="County required"
        >
          <q-input
            float-label="County"
            :value="billingAddressForm.COUNTY"
            :after="[
              {icon: 'flag', class: 'exclamation-circle-icon', condition: validation.billingAddressForm.COUNTY.$invalid, handler () {}},
              {icon: 'fa fa-check', condition: !validation.billingAddressForm.COUNTY.$invalid}
            ]"
            @blur="validation.billingAddressForm.COUNTY.$touch"
            @keyup.stop="updateBillingAddressForm({ field: 'COUNTY', value: $event.target.value })"
            :disable="!canEdit"
            required
          ></q-input>
        </q-field>
      </div>
    </div>
    <div class="shipping-address" style="margin-top:30px;">
      <h5>Mailing Address
        <q-checkbox
          style="margin-left:20px"
          :disable="!canEdit"
          v-model="shippingAddressForm.sameAsBilling"
          @input="val => setSameAsBilling({ status: val })"
        />
        <span style="font-size:15px">Same as Billing</span>
      </h5>
      <div v-if="!shippingAddressForm.sameAsBilling">
        <div class="row">
          <form autocomplete="off" class="col">
            <q-field
              class="q-pa-md col-12"
              :error="validation.shippingAddressForm.ADDRESS_1.$error"
              error-label="Address required"
            >
              <q-input
                float-label="Address 1"
                :value="shippingAddressForm.ADDRESS_1"
                :after="[
                {icon: 'flag', class: 'exclamation-circle-icon', condition: validation.shippingAddressForm.ADDRESS_1.$invalid },
                {icon: 'fa fa-check', condition: !validation.shippingAddressForm.ADDRESS_1.$invalid}
              ]"
                @blur="validation.shippingAddressForm.ADDRESS_1.$touch"
                :disable="!canEdit"
                v-places-autocomplete="shippingPlaceChanged"
                @keyup.stop="updateShippingAddressForm({ field: 'ADDRESS_1', value: $event.target.value })"
                autocomplete="off"
              ></q-input>
            </q-field>
          </form>
        </div>
        <div class="row">
          <form autocomplete="off" class="col">
            <q-field class="q-pa-md col-12">
              <q-input
                float-label="Address 2"
                :value="shippingAddressForm.ADDRESS_2"
                @keyup.stop="updateShippingAddressForm({ field: 'ADDRESS_2', value: $event.target.value })"
                :disable="!canEdit"
                required
                autocomplete="false"
              ></q-input>
            </q-field>
          </form>
        </div>
        <div class="row">
          <q-field
            class="q-pa-md col-3"
            :error="validation.shippingAddressForm.CITY.$error"
            error-label="City required"
          >
            <q-input
              float-label="City"
              :value="shippingAddressForm.CITY"
              :after="[
                {icon: 'flag', class: 'exclamation-circle-icon', condition: validation.shippingAddressForm.CITY.$invalid, handler () {}},
                {icon: 'fa fa-check', condition: !validation.shippingAddressForm.CITY.$invalid}
              ]"
              @blur="validation.shippingAddressForm.CITY.$touch"
              :disable="!canEdit"
              @keyup.stop="updateShippingAddressForm({ field: 'CITY', value: $event.target.value })"
            ></q-input>
          </q-field>

          <q-field
            class="q-pa-md col-3"
            :error="validation.shippingAddressForm.LK_STATE_ID.$error"
            error-label="State required"
          >
            <q-select
              float-label="State"
              :ref="'shippingStateDropdown'"
              :value="shippingAddressForm.LK_STATE_ID"
              :options="stateOptions"
              :after="[
                {icon: 'flag',  class: 'exclamation-circle-icon', condition: validation.shippingAddressForm.LK_STATE_ID.$invalid, handler () {}},
                {icon: 'fa fa-check', condition: !validation.shippingAddressForm.LK_STATE_ID.$invalid}
              ]"
              clearable
              :disable="!canEdit"
              @change="val => updateShippingAddressForm({ field: 'LK_STATE_ID', value: val })"
              @focus="onDropdownFocus('shippingStateDropdown')"
              filter
              autofocus-filter
            />
          </q-field>

          <q-field
            class="q-pa-md col-3"
            :error="validation.shippingAddressForm.ZIP_CODE.$error"
            error-label="Requires 5 characters"
          >
            <q-input
              float-label="Zip"
              :value="shippingAddressForm.ZIP_CODE"
              :after="[
                {icon: 'flag', class: 'exclamation-circle-icon', condition: validation.shippingAddressForm.ZIP_CODE.$invalid, handler () {}},
                {icon: 'fa fa-check', condition: !validation.shippingAddressForm.ZIP_CODE.$invalid}
              ]"
              @blur="validation.shippingAddressForm.ZIP_CODE.$touch"
              @keyup.stop="updateShippingAddressForm({ field: 'ZIP_CODE', value: $event.target.value })"
              :disable="!canEdit"
              required
            ></q-input>
          </q-field>

          <q-field
            class="q-pa-md col-3"
            :error="validation.shippingAddressForm.COUNTY.$error"
            error-label="County required"
          >
            <q-input
              float-label="County"
              :value="shippingAddressForm.COUNTY"
              :after="[
                {icon: 'flag', class: 'exclamation-circle-icon', condition: validation.shippingAddressForm.COUNTY.$invalid, handler () {}},
                {icon: 'fa fa-check', condition: !validation.shippingAddressForm.COUNTY.$invalid}
              ]"
              @blur="validation.shippingAddressForm.COUNTY.$touch"
              @keyup.stop="updateShippingAddressForm({ field: 'COUNTY', value: $event.target.value })"
              :disable="!canEdit"
              required
            ></q-input>
          </q-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters } from "vuex";
import {
  required,
  requiredUnless,
  minLength,
  maxLength,
  numeric
} from "vuelidate/lib/validators";

export default {
  name: "UserAddresses",
  props: ["validation"],
  data() {
    return {
      // addressForm: this.$store.state.users.addressForm
    };
  },
  // validations () {
  //   return {
  //     billingAddressForm: {
  //       ADDRESS_1: (this.affiliateForm.ACTIVE_IND || this.recruiterForm.ACTIVE_IND || this.instructorForm.ACTIVE_IND) ? { required } : { required: false },
  //       LK_STATE_ID: (this.affiliateForm.ACTIVE_IND || this.recruiterForm.ACTIVE_IND || this.instructorForm.ACTIVE_IND) ? { required } : { required: false },
  //       ZIP_CODE: (this.affiliateForm.ACTIVE_IND || this.recruiterForm.ACTIVE_IND || this.instructorForm.ACTIVE_IND) ? { required } : { required: false },
  //       CITY: (this.affiliateForm.ACTIVE_IND || this.recruiterForm.ACTIVE_IND || this.instructorForm.ACTIVE_IND) ? { required } : { required: false },
  //       COUNTY: (this.affiliateForm.ACTIVE_IND || this.recruiterForm.ACTIVE_IND || this.instructorForm.ACTIVE_IND) ? { required } : { required: false }
  //     },
  //     shippingAddressForm: {
  //       ADDRESS_1: (!this.sameAsBilling && ( this.affiliateForm.ACTIVE_IND || this.recruiterForm.ACTIVE_IND || this.instructorForm.ACTIVE_IND )) ? { required } : { required: false },
  //       LK_STATE_ID: (!this.sameAsBilling && ( this.affiliateForm.ACTIVE_IND || this.recruiterForm.ACTIVE_IND || this.instructorForm.ACTIVE_IND )) ? { required } : { required: false },
  //       ZIP_CODE: (!this.sameAsBilling && ( this.affiliateForm.ACTIVE_IND || this.recruiterForm.ACTIVE_IND || this.instructorForm.ACTIVE_IND )) ? { required } : { required: false },
  //       CITY: (!this.sameAsBilling && ( this.affiliateForm.ACTIVE_IND || this.recruiterForm.ACTIVE_IND || this.instructorForm.ACTIVE_IND )) ? { required } : { required: false },
  //       COUNTY: (!this.sameAsBilling && ( this.affiliateForm.ACTIVE_IND || this.recruiterForm.ACTIVE_IND || this.instructorForm.ACTIVE_IND )) ? { required } : { required: false },
  //     }
  //   }
  // },
  computed: {
    // validation () {
    //   return this.$v
    // },
    ...mapGetters(["stateOptions"]),
    ...mapState("users", {
      billingAddressForm: state => state.billingAddressForm,
      shippingAddressForm: state => state.shippingAddressForm,
      sameAsBilling: state => state.shippingAddressForm.sameAsBilling,
      instructorForm: state => state.instructorForm,
      affiliateForm: state => state.affiliateForm,
      recruiterForm: state => state.recruiterForm,
      canEdit: state => state.userModal.canEdit
    })
  },
  methods: {
    ...mapMutations("users", [
      "updateBillingAddressForm",
      "updateShippingAddressForm",
      "setSameAsBilling",
      "autocompleteAddress",
      "clearBillingAddressForm",
      "clearShippingAddressForm",
    ]),

    onDropdownFocus(index) {
      let dropdown = this.$refs[index];
      dropdown.show();
    },
    billingPlaceChanged(place) {
      return this.autocompleteAddress({
        place,
        type: "billingAddressForm",
        stateOptions: this.stateOptions
      });
    },
    shippingPlaceChanged(place) {
      return this.autocompleteAddress({
        place,
        type: "shippingAddressForm",
        stateOptions: this.stateOptions
      });
    }

    // successHandler (response) {
    //   this.$v.$reset()
    // }
    // shouldValidateAddress () {
    //   return (_.includes(this.roles, 'Affiliate') || _.includes(this.roles, 'Recruiter') || _.includes(this.roles, 'Instructor')) ? { required } : {}
    // },
  }
};
</script>

<style scoped lang="stylus">
.exclamation-circle-icon {
  font-size: 1.4rem !important;
}

.q-tabs-panes {
  display: flex;
  // overflow: scroll;
  // max-width: 1400px;
  // margin: auto;
}

form {
  width: 100%;
}

.sl-row.sl-abs {
  height: calc(100% - 110px);
}
</style>
